import styled from 'styled-components';

type Props = {};

export default styled.section<Props>`
  .box-button {
    span {
      font-size: 14px;
    }
  }
  overflow-x: hidden;

  .bo-body {
    height: calc(100vh - 114px);
  }
  .bo-header {
    position: fixed;
    width: 100%;
    z-index: 98;
    margin-top: -50px;
    background: #f7f7f7;
    padding: 10px 32px;
  }
  .bo-content {
    margin-top: 50px;
  }
`;

export const WorkerShiftTableStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  margin-left: -2px;
  margin-right: -2px;
  .ant-table {
    .ant-table-content {
      table {
        padding: 0px 2px;
      }
      .ant-table-thead {
        > tr {
          > th {
            padding-top: 12px;
            padding-left: 16px;
            padding-bottom: 8px;
          }
        }
      }
      .ant-table-tbody {
        tr {
          td {
            padding: 16px 24px 24px 24px;
          }
        }
        .ant-table-row {
          td {
            padding-top: 16px;
            padding-left: 16px;
            padding-bottom: 18px;
          }
        }
        tr:first-child {
          td:first-child {
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
          }
          td:last-child {
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
          }
        }
        tr:last-child td:first-child {
          border-bottom-left-radius: 8px;
        }
        tr:last-child td:last-child {
          border-bottom-right-radius: 8px;
        }
      }
    }
  }
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） start
  .error-message {
    color: red;
    padding: 0 50px;
    margin-top: 10px;
  }
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） end

  & .ant-table-container {
    width: 100vw;
    padding: 0 32px;
  }
  & .ant-table-wrapper {
    & .ant-table .ant-table-content .ant-table-thead {
      tr {
        th {
          &:first-child {
            padding-left: 24px;
          }
          &:last-child {
            padding-right: 24px;
          }
        }
      }
    }
    & .ant-table .ant-table-content .ant-table-tbody {
      tr {
        td {
          &:first-child {
            padding-left: 24px;
          }
          &:last-child {
            padding-right: 24px;
          }
        }
      }
    }
  }
  .separate {
    height: 8px;
  }
`;
